import type { PropsWithChildren, ReactElement } from "react"

import styled from "styled-components"

const ImageContainer = styled.div`
  align-self: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  color: var(--blue);
  transition: 0.1s ease-in-out;
`

export interface RadioButtonProps<T> {
  options: {
    key: T
    label: string
    imageUrl: ReactElement
  }[]
  className?: string
  value: T
  setValue: (value: T) => void
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export const Choice = <T extends string>({
  options,
  className,
  value,
  setValue,
}: PropsWithChildren<RadioButtonProps<T>>): ReactElement<any, any> => {
  return (
    <>
      {options.map((option) => {
        const { key, label } = option

        return (
          <label key={key} className={className}>
            <input
              type="radio"
              name="radio"
              value={key}
              checked={key === value}
              onChange={() => setValue(key)}
            />
            <div className="bg" />
            {option.imageUrl && (
              <ImageContainer className="image">
                {option.imageUrl}
              </ImageContainer>
            )}
            <h1>{label}</h1>
          </label>
        )
      })}
    </>
  )
}
/* eslint-enable @typescript-eslint/no-explicit-any */

export const BasicChoice = styled(Choice)`
  display: inline-flex;
  justify-content: space-between;
  position: relative;
  padding: 20px;
  font-size: 21px;
  cursor: pointer;
  justify-content: flex-start;
  span {
    margin-left: 10px;
  }
  .border,
  input[type="radio" i] {
    border: 2px solid lightgray;
  }
  .bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  input[type="radio" i] {
    height: 15px;
    width: 15px;
    cursor: default;
    appearance: unset;
    box-sizing: border-box;
    margin: 6px 6px 6px 6px;
    box-sizing: border-box;
    outline: none;
    &:checked {
      border-color: var(--color-fg);
      background: var(--color-fg);
      ~ .bg {
        border-color: var(--color-fg);
        border-width: 2px;
      }
    }
  }
`
